import React,{ useState } from "react";
import {ContentList} from './contentlist';
import { ContentStatus, ContentSetActions } from '../../types/content.types';
import { makeUserContentLink } from "../../utils/linkbuilder";
import { ConfirmPane, ConfirmPaneLockScroll } from "../../components/confirmpane";

const SCREEN_TITLE:string="Content Sets";
const INTRO_TEXT="Use this page to create sets of images to use with the games on this site.  After creating a set, a link will appear at the bottom of the page.  You can follow the link to play a game with your set of images."
const CHINA_TEXT="China warning - any sets you create may not be accessible for students in China.";

interface PropsType{
    contentStatus:ContentStatus;
	usermail:string;
    userContentList:string[];
    getContentSet:(contentSet: string) => void;
    newContentSet:() => void;
    contentSetMenuClick:(contentSetAction: ContentSetActions, contentSet:string) => void;
}

const ContentSets=function(props:PropsType){

    const [showConfirmPane, setShowConfirmPane] = useState(false);
    const [setToDelete, setSetToDelete] = useState('');

    const actionClick = (myAction:ContentSetActions, contentSet: string) => {
        if(myAction===ContentSetActions.View)props.getContentSet(contentSet);
        if(myAction===ContentSetActions.Open)openSet(contentSet);
        if(myAction===ContentSetActions.Delete)deleteSet(contentSet);
    }

    const openSet=function(contentSet:string){
        const win = window.open(makeUserContentLink('vocab',props.usermail,contentSet), '_blank');
        if (win != null)win.focus();
    }

    const deleteSet=function(contentSet:string){
        setSetToDelete(contentSet);
        setShowConfirmPane(true);
        ConfirmPaneLockScroll(true);
    }
    
    const deleteConfirmPaneClick=function(isConfirmed:boolean){
        ConfirmPaneLockScroll(false);
        setShowConfirmPane(false);
        if(isConfirmed)props.contentSetMenuClick(ContentSetActions.Delete, setToDelete);
    }

    let isLoggedIn=props.usermail!=='';

    if(props.contentStatus===ContentStatus.DeleteSet){
        return <DeletingMsg />
    }else{
        return(
            <div className='teachers-content'>
                <hr />
                <h3>{SCREEN_TITLE}</h3>
                {props.userContentList.length===0&&<ContentHeader />}
                <button onClick={()=>{props.newContentSet();}} className='teachers-button teachers-button-default'>Create Set</button>
                {props.userContentList.length>0&&<ContentList
                    isLoggedIn={isLoggedIn}
                    contentStatus={props.contentStatus}
                    userContentList={props.userContentList}
                    actionClick={(myAction:ContentSetActions, contentSet:string)=>{actionClick(myAction, contentSet);}}
                />}
                <ConfirmPane
                    showConfirm={showConfirmPane}
                    confirmClick={deleteConfirmPaneClick}
                    confirmMessage={`Delete ${setToDelete}`} />
            </div>
        );
    }
}

export default ContentSets;

const ContentHeader=function(){
    return(
        <div>
            <p>{INTRO_TEXT}</p>
            <p>{CHINA_TEXT}</p>
        </div>
    );
}

const DeletingMsg=function(){
    return(
        <div>
            <hr />
            <p className="teachers-statusmessage">Deleting set</p>
        </div>
    );
}